import { Translate } from "../../../../../../../../constant/Translate"
import { GridItemType } from "../../../../../../../../_webui/layout/components/Grid/models"
import { ScheduleInfoType } from "../../../../../models/addSuccess"
import { getValueOrUndecided } from "../../../../../../../../utils/getValueOrUndecided"

const { TEXT_T199, TEXT_T200, TEXT_T219, TEXT_T236 } = Translate

export const getAssignmentGridConfig = (
  scheduleInfo: ScheduleInfoType,
): GridItemType[] => [
  {
    key: TEXT_T199,
    text: scheduleInfo.projectNameJp,
  },
  {
    key: TEXT_T200,
    text: scheduleInfo.projectNameEn,
  },
  {
    key: TEXT_T219,
    text: getValueOrUndecided(scheduleInfo.locationToSendMailName),
  },
  {
    key: TEXT_T236,
    text: scheduleInfo.locationPersonName,
  },
]
